import emptyBpListState from 'features/bpList/ducks/state'
import {
  fetchUserBpsRoutine,
  getBuildingTypesRoutine,
  searchBpsRoutine,
  getBpsPricesRoutine,
  fetchFavouritesRoutine,
  getBpsCountRoutine,
  getUnitsCountRoutine,
  clearBpPricesRoutine,
  searchFilesRoutine,
  toggleFavouriteRoutine
} from 'features/bpList/ducks/actions'
import { pathOr, propOr } from 'ramda'
import { cancelInvitationRoutine, getInvitationsListForBpRoutine } from 'features/accessControl/ducks/actions'
import { logoutUserRoutine } from 'features/auth/ducks/actions'
import { removeBpRoutine } from 'features/createBp/ducks/actions'

export default (state = emptyBpListState, action) => {
  switch (action.type) {
    case fetchUserBpsRoutine.SUCCESS: {
      const incoming = pathOr([], ['payload', 'data'], action)
      const currentPage = pathOr(1, ['payload', 'meta', 'currentPage'], action)
      const merged = currentPage > 1
        ? [...state.entries, ...incoming.filter(i => !state.entries.some(e => e.id === i.id))]
        : incoming
      return {
        ...state,
        entries: merged,
        totalPages: pathOr(1, ['payload', 'meta', 'lastPage'], action),
        totalFound: pathOr(1, ['payload', 'meta', 'total'], action)
      }
    }

    case toggleFavouriteRoutine.SUCCESS:
      return {
        ...state,
        entries: state.entries.map(bp => {
          if (bp.id === action.payload) {
            const isFav = bp.is_favourite || bp.isFavourite
            return { ...bp, is_favourite: !isFav, isFavourite: !isFav }
          }
          return bp
        }),
        favourites: {
          ...state.favourites,
          entries: state.favourites.entries.filter(bp => bp.id !== action.payload)
        }
      }

    case removeBpRoutine.SUCCESS:
      return {
        ...state
        // entries: state.entries.filter(e => e.id !== action.payload)
      }
    case fetchFavouritesRoutine.SUCCESS:
      return {
        ...state,
        favourites: {
          ...state.favourites,
          entries: pathOr(1, ['payload', 'data'], action),
          totalPages: pathOr(1, ['payload', 'meta', 'lastPage'], action),
          totalFound: pathOr(1, ['payload', 'meta', 'total'], action)
        }
      }
    case getBpsPricesRoutine.TRIGGER:
    case getBpsPricesRoutine.REQUEST:
      return {
        ...state,
        pricesStatus: 'loading'
      }
    case getBpsPricesRoutine.SUCCESS:
      return {
        ...state,
        prices: propOr([], 'payload', action),
        pricesStatus: 'success'
      }
    case getBpsPricesRoutine.FAILURE:
      return {
        ...state,
        pricesStatus: 'failure'
      }
    case clearBpPricesRoutine.SUCCESS:
      return {
        ...state,
        prices: [],
        pricesStatus: 'idle'
      }
    case searchBpsRoutine.SUCCESS:
      return {
        ...state,
        searchBpResults: pathOr([], ['payload', 'data'], action)
      }
    case searchFilesRoutine.SUCCESS:
      return {
        ...state,
        searchFileResults: pathOr([], ['payload', 'data'], action)
      }
    case getBuildingTypesRoutine.SUCCESS:
      return {
        ...state,
        buildingTypes: action.payload
      }
    case getInvitationsListForBpRoutine.SUCCESS:
      return {
        ...state,
        invitations: action.payload
      }
    case cancelInvitationRoutine.SUCCESS:
      return {
        ...state,
        invitations: Array.isArray(state.invitations)
          ? state.invitations.filter(inv => inv.id !== action.payload?.invitationId)
          : state.invitations
      }
    case logoutUserRoutine.SUCCESS:
      return emptyBpListState
    case getBpsCountRoutine.SUCCESS:
      return {
        ...state,
        bpsCount: action.payload
      }
    case getUnitsCountRoutine.SUCCESS:
      return {
        ...state,
        unitsCount: action.payload
      }
    default:
      return state
  }
}
